import React from 'react';
import {Link, useLocation} from "react-router-dom";

import '../style/css/components/Header.css';
import lpLogo from '../img/lp_developer-08.png';

function Header(){

	let logoSizeClass = '';
	// let mainWrapper = document.getElementsByClassName('mainWrapper')[0];
	if(useLocation().pathname !== '/'){
		logoSizeClass = 'innerPage'
		// if(mainWrapper){
			// mainWrapper.className = 'mainWrapper innerPage'
		// }
	}else{
		logoSizeClass = ''
		// if(mainWrapper){
			// mainWrapper.className = 'mainWrapper'
		// }
	}

	return (
		<header className={`container-fluid header ${logoSizeClass}`}>
			<div className='row'>
				<div className="container-fluid">

					<div className="row justify-content-center">
						<Link to='/' className="col">
							<img className='header_logo' src={lpLogo} alt="Lucas Pedro Developer logo" title='Lucas Pedro Developer logo' />
						</Link>
					</div>

				</div>
			</div>
		</header>
	);
}

export default Header;
